import bustPolymorphicCache from './bust-dependent-resource-cache'

export {
  bustPolymorphicCache,
}

export default [
  bustPolymorphicCache,
]
